// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';

import { Helmet } from 'react-helmet-async';

import { useAppSelector } from '@shared/store';
import { formatPageTitle } from '@shared/utils/pageTitle';

type Props = {
  description?: string;
  children: React.JSX.Element | React.JSX.Element[];
  /** Screen name only (e.g. "Campaign List"); formatted as "{title} | {companyName or product}". */
  title?: string;
  /** Company display name for the tab suffix; falls back to authenticated company, then product branding. */
  companyName?: string;
  /** Force product name suffix (Call Agent). Use on sign-in and other unauthenticated routes. */
  useProductSuffix?: boolean;
};

const PageContainer = ({
  title,
  companyName,
  useProductSuffix = false,
  description,
  children,
}: Props) => {
  const authenticatedCompanyTitle = useAppSelector(
    (state) => state.auth.authenticatedUserCompany?.title,
  );
  const suffixCompanyName = useProductSuffix
    ? undefined
    : (companyName ?? authenticatedCompanyTitle);
  const documentTitle = formatPageTitle(title, suffixCompanyName);
  const metaDescription = description ?? documentTitle;

  return (
    <div>
      <Helmet>
        <title>{documentTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>
      {children}
    </div>
  );
};

export default PageContainer;
